import { NgModule } from "@angular/core";
import { SharedModule } from "../../../../shared";

@NgModule({
    declarations: [],
    imports: [ SharedModule],
    providers: [],
    exports: [],
    entryComponents: []
  })
  export class TechnicalManagementSharedModule { }
